import { render, staticRenderFns } from "./DeploymentsTable.vue?vue&type=template&id=89d3bf26&"
import script from "./DeploymentsTable.vue?vue&type=script&lang=js&"
export * from "./DeploymentsTable.vue?vue&type=script&lang=js&"
import style0 from "./DeploymentsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports